import { UserBase, UserBaseFromJSON } from '@/api/models/user/UserBase'

export interface CreateUserSimpleRequest {
  id: string
  name: string
  nameKana: string
  address: string
  birthday: string
  gender: string
  phoneNumber: string
  mailAddress: string
}

export function CreateUserSimpleRequestToJSON(
  value: CreateUserSimpleRequest
): any {
  return {
    id: value.id,
    name: value.name,
    name_kana: value.nameKana,
    address: value.address,
    birthday: value.birthday,
    gender: value.gender,
    phone_number: value.phoneNumber,
    mail_address: value.mailAddress
  }
}

export interface CreateUserSimpleResponse {
  base: UserBase
}

export function CreateUserSimpleResponseFromJSON(
  json: any
): CreateUserSimpleResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    base: UserBaseFromJSON(json.base)
  }
}
